import { getJsonApiSubmitError } from 'api/utils/apiErrorMessages';
import {
  postAnswerListSubmissionError,
  knownErrorsMap as defaultKnownErrorsMap,
  defaultError as defaultTakerError,
} from 'taker/api/utils/takerApiErrors';

export const getRejectionError = rejection =>
  rejection && rejection.errors && rejection.errors[0];

export const getErrorType = rejectionError =>
  rejectionError.meta && rejectionError.meta.type;

const getKnownError = (rejection, knownErrorsMap) => {
  const rejectionError = getRejectionError(rejection);
  if (!rejectionError) {
    return;
  }

  const knownErrorDomain = knownErrorsMap[rejectionError.name];
  if (!knownErrorDomain) {
    return;
  }

  const knownError = knownErrorDomain[getErrorType(rejectionError)];
  if (!knownError) {
    return;
  }

  const message = knownError.messageFn
    ? knownError.messageFn(rejectionError)
    : knownError.message;

  return {
    ...knownError,
    message,
  };
};

export const generateTakerRejection = (
  knownErrorsMap = defaultKnownErrorsMap,
  defaultError = defaultTakerError,
) => rejection =>
  Promise.reject(
    getKnownError(rejection.response.data, knownErrorsMap) ||
      getJsonApiSubmitError(
        rejection.response.data,
        postAnswerListSubmissionError,
      ) ||
      defaultError,
  );
